import { module } from '../app';

module.service('fingerprintService', [function () {
  this.getFingerprint = async function () {
    const webgl = getWebGLFingerprint();
    const fonts = getInstalledFonts();
    const plugins = getBrowserPlugins();
    const motionData = await getMotionData();
    const canvas = getCanvasFingerprint();
    const rawData = [webgl, fonts, plugins, motionData, canvas].join('|');
    const hashHex = djb2Hash(rawData).toString(16);
    return hashHex;
  };

  function djb2Hash(str) {
    let hash = 5381;
    for (let i = 0; i < str.length; i++) {
      hash = ((hash << 5) + hash) + str.charCodeAt(i);
    }
    return hash >>> 0;
  }

  function getWebGLFingerprint() {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl');
    if (!gl) return '';
    const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
    return debugInfo ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) : '';
  }

  function getMotionData() {
    return new Promise(resolve => {
      if (!window.DeviceMotionEvent) {
        resolve('');
        return;
      }
      const readings = [];
      setTimeout(() => {
        window.removeEventListener('devicemotion', handler);
        resolve(JSON.stringify(readings, null, 2));
      }, 1000);
      function handler(event) {
        readings.push({
          acceleration: {
            x: event.acceleration.x,
            y: event.acceleration.y,
            z: event.acceleration.z
          },
          rotationRate: {
            alpha: event.rotationRate.alpha,
            beta: event.rotationRate.beta,
            gamma: event.rotationRate.gamma
          }
        });
      }
      window.addEventListener('devicemotion', handler);
    });
  }

  function getInstalledFonts() {
    const fonts = ['Arial', 'Verdana', 'Times New Roman', 'Courier New', 'Georgia'];
    const testCanvas = document.createElement('canvas');
    const ctx = testCanvas.getContext('2d');
    if (!ctx) return '';
    return fonts.filter(font => {
      ctx.font = `72px ${font}`;
      return ctx.measureText('test').width !== 0;
    }).join(',');
  }

  function getBrowserPlugins() {
    return navigator.plugins.length
      ? Array.from(navigator.plugins).map(p => p.name).join(',')
      : '';
  }

  function getCanvasFingerprint() {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) return '';
    ctx.textBaseline = 'top';
    ctx.font = '16px "Arial"';
    ctx.fillStyle = '#f60';
    ctx.fillRect(50, 10, 200, 50);
    ctx.fillStyle = '#069';
    ctx.fillText('CanvasTest', 55, 40);
    return canvas.toDataURL();
  }
}]);



// WEBPACK FOOTER //
// ./src/scripts/services/fingerprint.service.js